<template>
<div>
    <h2>ทำรายการสรุปยอด พนักงาน</h2>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">
        <div class="d-flex justify-space-between mb-3">
            <h2>รายการ</h2>
            <h2>ยอดรวมทั้งหมด {{ currencyFormat(data.reduce((sum,number) => { return sum + ((number.salary + number.cal_ot) - number.minus_total) }, 0)) }} บาท</h2>
        </div>
        <v-card class="pa-3 mb-3" v-for="(detail,index) in data" :key="index">
            <div class="d-flex justify-space-between mb-3">
                <h3>ชื่อ-สกุล : {{ detail.nickname }}</h3>
                <h3>รวม {{ currencyFormat((detail.salary + detail.cal_ot) - detail.minus_total) }} บาท</h3>
            </div>
            <div class="grid_detail_detail_part_time_summary_list">
                <div>
                    <div>วันทำงานรวม : {{ detail.work_count }} วัน</div>
                    <div>OT รวม : {{ detail.ot }} ชั่วโมง</div>
                    <div>หักเงินรวม : {{ currencyFormat(detail.minus_total) }} บาท</div>
                </div>
                <div>
                    <div>เงินเดือน : {{ detail.salary }} บาท</div>
                    <div>มูลค่า OT รวม : {{ currencyFormat(detail.cal_ot) }} บาท</div>
                    <!-- <div>
                        <v-btn color="error" class="white--text" @click="openDeductMoney(detail.id)" width="50%" height="50">
                            รายการหักเงิน
                        </v-btn>
                    </div> -->

                </div>
            </div>
            <div class="text-center">
                <v-btn color="success" width="40%" height="50" class="mr-1" @click="pdfPage(detail.id,1)">
                    <div>ใบแจ้งเงินเดือน</div>
                    <v-icon>mdi-printer</v-icon>
                </v-btn>
                <v-btn color="success" width="40%" height="50" class="ml-1" @click="pdfPage(detail.id,2)">
                    <div>รายงานการเข้า-ออกพนักงาน</div>
                    <v-icon>mdi-printer</v-icon>
                </v-btn>
            </div>
        </v-card>
        <!-- <v-dialog v-model="open_deduct_money" persistent max-width="600px">
            <div v-if="loading_detail_page === true">
                <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                    <v-skeleton-loader type="article, actions"></v-skeleton-loader>
                </v-sheet>
            </div>
            <v-card v-if="loading_detail_page === false">
                <v-card-title class="justify-space-between">
                    <div>
                        รายการหักเงิน
                    </div>
                    <div class="cursor_detail_part_time_summary_list" @click="open_deduct_money = false">
                        <v-icon>mdi-close</v-icon>
                    </div>
                </v-card-title>

                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <div class="text-right mb-3">
                                    <h2>
                                        ยอดรวมทั้งหมด {{ broken_item_price_all }} บาท
                                    </h2>
                                </div>
                                <div class="d-flex mb-3 pb-2 deduct_money_detail_part_time_summary_list">
                                    <div class="mr-1">ยอดหักประกันสังคม %</div>
                                    <div class="ml-1">ยอดหัก (บาท)</div>
                                </div>
                                <div class="d-flex mb-3 detail_deduct_money_detail_part_time_summary_list">
                                    <div class="mr-1">
                                        {{ social_security }}
                                    </div>
                                    <div class="ml-1 mr-1 d-flex align-center">
                                        {{ currencyFormat((social_security * salary) / 100) }}
                                    </div>
                                    <div class="ml-1">

                                    </div>
                                </div>
                                <div class="d-flex mb-3 pb-2 deduct_money_detail_part_time_summary_list">
                                    <div class="mr-1">รายการหักอื่นๆ</div>
                                    <div class="ml-1">ยอดหักอื่นๆ (บาท)</div>
                                </div>
                                <div class="d-flex mb-1 detail_deduct_money_detail_part_time_summary_list" v-for="(broken_item,index) in broken_item_list" :key="index">
                                    <div class="mr-1">
                                       {{ broken_item.name }}
                                    </div>
                                    <div class="ml-1 mr-1">
                                        {{ broken_item.price }}
                                    </div>
                                    <div class="ml-1 d-flex justify-center align-center">

                                    </div>

                                </div>
                            </v-col>

                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>

                </v-card-actions>

            </v-card>
        </v-dialog> -->
    </div>
</div>
</template>

<script>
import summary from '@/api/team/teamreportsummary/summary.js'
import {
    currencyFormat
} from '@/helper/numberformat.js'
export default {
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: false,
            loading_detail_page: true,
            open_deduct_money: false,
            data: [],
            social_security: '',
            salary: '',
            broken_item_list: [],
        }
    },
    methods: {
        currencyFormat,
        async detailEmployeeOrPartTime() {
            this.loading_page = true
            summary.detailEmployeeOrPartTime(this.$store.state.detailEmployeeSummaryId).then((response) => {
                if (response.data.successful === true) {
                    response.data.condetail.forEach(detail => {
                        this.data.push({
                            id: detail.id,
                            nickname: detail.employee_name,
                            work_count: detail.sum_day,
                            ot: detail.sum_ot,
                            minus_total: detail.sum_deduct_money == null ? 0 : parseInt(detail.sum_deduct_money),
                            salary: detail.salary == null ? 0 : parseInt(detail.salary),
                            cal_ot: detail.value_ot == null ? 0 : parseInt(detail.value_ot),
                        })
                    })
                }
                this.loading_page = false
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async pdfPage(id, type) {
            if (type == 1) {
                window.open(
                    `${process.env.VUE_APP_BASE_URL}salaryEmployee/?conswork_id=${id}`,
                    '_blank'
                );
            }
            if (type == 2) {
                window.open(
                    `${process.env.VUE_APP_BASE_URL}shiftEmployee/?conswork_id=${id}`,
                    '_blank'
                );
            }
        },
        // async openDeductMoney(id) {
        //     let deduct_money_list = this.data.find((detail) => {
        //         return detail.id == id
        //     })

        //     this.salary = deduct_money_list.salary
        //     this.loading_detail_page = true
        //     this.open_deduct_money = true
        //     this.broken_item_list = []
        //     summary.detailDeductionItemEmployeeOrPartTime(id).then((response) => {
        //         if (response.data.successful === true) {
        //             response.data.conclusionWorkLists.forEach((detail, index) => {
        //                 if (detail.type_deduction == 0) {
        //                     this.broken_item_list.push({
        //                         id: index + 1,
        //                         name: detail.name,
        //                         price: detail.price,
        //                     })
        //                 }
        //                 if (detail.type_deduction == 1) {
        //                     this.social_security = detail.name
        //                 }
        //             })
        //             if (this.broken_item_list.length == 0) {
        //                 this.broken_item_list.push({
        //                     id: 1,
        //                     name: null,
        //                     price: '',
        //                 })
        //             }
        //             this.loading_detail_page = false
        //         }
        //     }).catch((error) => {
        //         if (error.response.status === 401) {
        //             this.$store.commit('logOutSuccess')
        //             this.$router.push('/login')
        //         }
        //     })
        // },
    },
    // computed: {
    //     broken_item_price_all() {
    //         let sum_all = 0
    //         if (this.salary !== '') {
    //             sum_all += parseInt(this.salary)
    //         }
    //         if (this.social_security !== '') {
    //             sum_all -= parseInt((this.social_security * this.salary) / 100)
    //         }
    //         this.broken_item_list.forEach((detail) => {
    //             if (detail.price !== '') {
    //                 sum_all -= parseInt(detail.price)
    //             }
    //         })

    //         return currencyFormat(sum_all)
    //     }

    // },
    mounted() {
        this.detailEmployeeOrPartTime()
    }
}
</script>

<style scoped>
.startdate_detail_part_time_summary_list,
.enddate_detail_part_time_summary_list {
    width: 40%;
}

.searchdate_detail_part_time_summary_list {
    width: 20%;
}

.grid_detail_detail_part_time_summary_list {
    display: grid;
    grid-template-columns: 50% 50%;
    grid-row-gap: 10px;
}

.cursor_detail_part_time_summary_list {
    cursor: pointer;
}

.deduct_money_detail_part_time_summary_list {
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
}

.deduct_money_detail_part_time_summary_list>div {
    width: 45%;
    font-size: 22px;
}

.deduct_money_detail_part_time_summary_list>div:nth-child(2) {
    width: 55%;
}

.detail_deduct_money_detail_part_time_summary_list>div {
    width: 45%;
    font-size: 18px;
}

.detail_deduct_money_detail_part_time_summary_list>div:nth-child(3) {
    width: 10%;
}
</style>
